var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogoutWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:10;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 320,
    height: 320
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "133.3,133.3 133.3,89.6 246.1,89.6 246.1,231.2 135.1,231.2 135.1,186.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 189.7,
    y1: 160,
    x2: 74,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 101.2,
    y1: 132.7,
    x2: 73.9,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 101.2,
    y1: 187.3,
    x2: 73.9,
    y2: 160
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoutWhite);
export default __webpack_public_path__ + "static/media/ic_logout_white.a5c34c0ddd2294dd31a2e959ace252d9.svg";
export { ForwardRef as ReactComponent };